// Make these accessible globally
const maxItems = 4;
const selectedItems = new Map();

function updateBundleUI() {
  const bundleList = document.querySelector('.pcx-bundle-cart__list');
  const bundleInputs = document.querySelector('.pcx-bundle-cart__inputs');
  const addToCartBtn = document.getElementById('final-add-to-cart-btn');
  if (!bundleList || !addToCartBtn || !bundleInputs) return;

  bundleList.innerHTML = '';
  bundleInputs.innerHTML = '';

  const items = Array.from(selectedItems.entries());
  for (let i = 0; i < maxItems; i++) {
    const item = items[i];
    const wrapper = document.createElement('div');
    wrapper.classList.add('pcx-bundle-cart__item');

    if (item) {
      const [id, data] = item;

      wrapper.innerHTML = `
        <img class="pcx-bundle-cart__image" src="${data.image}" alt="${data.title}">
        <div class="pcx-bundle-cart__content">
          <div class="pcx-bundle-cart__title">${data.title}</div>
          ${data.roast ? `<div class="pcx-bundle-cart__roast">${data.roast} Roast</div>` : ''}
          <div class="pcx-bundle-cart__price">${data.price}</div>
        </div>
        <button class="pcx-bundle-cart__remove" data-product-id="${id}" aria-label="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
        </button>`;

      bundleInputs.innerHTML += `<input type="hidden" name="items[${i}][id]" value="${id}"><input type="hidden" name="items[${i}][quantity]" value="1">`;
    } else {
      wrapper.classList.add('pcx-bundle-cart__item--placeholder');
      wrapper.innerHTML = `
        <div class="pcx-bundle-cart__image"><div class="pcx-bundle-cart__image-inner"></div></div>
        <div class="pcx-bundle-cart__content">
          <div class="pcx-bundle-cart__title">Choose a Coffee</div>
          <div class="pcx-bundle-cart__price">$0.00</div>
        </div>`;
    }

    bundleList.appendChild(wrapper);
  }

  document.querySelectorAll('.pcx-bundle-cart__remove').forEach(removeBtn => {
    removeBtn.addEventListener('click', e => {
      const id = e.currentTarget.dataset.productId;
      selectedItems.delete(id);
      const btn = document.querySelector(`.add-bundle-btn[data-product-id="${id}"]`);
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to Bundle';
      }
      updateBundleUI();
    });
  });

  const subtotal = Array.from(selectedItems.values()).reduce((sum, item) => {
    const clean = parseFloat(item.price.replace(/[^0-9.]/g, '')) || 0;
    return sum + clean;
  }, 0);

  const discount = 5;
  const final = Math.max(0, subtotal - discount);

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(final);

  addToCartBtn.disabled = selectedItems.size < maxItems;
  addToCartBtn.innerHTML = selectedItems.size < maxItems
    ? `${selectedItems.size}/${maxItems} Selected`
    : `Add to Cart – ${formatted} <span class="pcx-bundle-subtotal-strikethrough"> $${subtotal}</span>`;
}

function bindAddButtons() {
  document.querySelectorAll('.add-bundle-btn').forEach(btn => {
    if (btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', () => {
      const id = btn.dataset.productId;
      if (selectedItems.has(id) || selectedItems.size >= maxItems) return;

      selectedItems.set(id, {
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice,
        roast: btn.dataset.productRoast,
        flavour: btn.dataset.productFlavour
      });

      btn.disabled = true;
      btn.textContent = 'Added';

      updateBundleUI();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  bindAddButtons();
  updateBundleUI();
});

// Rebind on filter change
document.addEventListener('facet:render', () => {
  bindAddButtons();
});

// Bundle cart form event script
document.getElementById('bundle-cart-form').addEventListener('submit', function (e) {
  e.preventDefault();

  const form = this;
  const inputs = form.querySelectorAll('input[name^="items["]');
  const items = [];

  inputs.forEach(input => {
    const match = input.name.match(/items\[(\d+)]\[(id|quantity)]/);
    if (match) {
      const index = match[1];
      const key = match[2];
      if (!items[index]) items[index] = {};
      items[index][key] = parseInt(input.value, 10);
    }
  });

  const cartDrawer = document.querySelector('cart-drawer');

  const body = JSON.stringify({
    items,
    sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-footer', 'main-cart-items'],
    sections_url: window.location.pathname
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body
  })
    .then(res => {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(() => {
      // fetch updated HTML for cart drawer
      return fetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-footer,main-cart-items')
        .then(res => res.json());
    })
    .then(sections => {
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
        window.location.href = '/cart';
        return;
      }

      // Important: cartDrawer.renderContents expects this structure
      const parsedState = {
        sections,
        id: null // optional but Dawn checks for this
      };

      CartPerformance?.measure("add:paint-updated-sections", () => {
        cartDrawer.renderContents(parsedState);
        cartDrawer.classList.remove('is-empty');
      });

      // Let other components know cart was updated
      publish?.(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-cart-form',
        cartData: parsedState
      });
    })
    .catch(err => {
      console.error('Bundle Add to Cart failed:', err);
    });
});


let nextPageUrl = document.getElementById("load-more-button")?.dataset.nextPage;
const sentinel = document.getElementById("infinite-scroll-sentinel");

if (sentinel && nextPageUrl) {
  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && nextPageUrl) {
      observer.unobserve(sentinel); // temporarily stop watching

      fetch(nextPageUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newItems = doc.querySelectorAll(".product-grid .grid__item");
          const productGrid = document.querySelector(".product-grid");
          newItems.forEach(item => productGrid.appendChild(item));

          // Update nextPageUrl
          const nextButton = doc.getElementById("load-more-button");
          nextPageUrl = nextButton?.dataset.nextPage || null;

          bindAddButtons();
          updateBundleUI();

          if (nextPageUrl) {
            observer.observe(sentinel); // watch again if more pages exist
          } else {
            sentinel.style.display = 'none';
          }
        });
    }
  }, {
    rootMargin: '100px',
  });

  observer.observe(sentinel);
}